import { Icon, IconProps } from "../";

export const Trenchcoat = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 56 56" {...props}>
      <>
        <path
          d="M17.4947 12.248H21.7137V14.347H23.8126V16.4459H32.1874V14.347H34.2863V12.248H38.5053V14.347H40.6042V16.4459H42.7032V18.5449H44.8021V20.6438H46.9011V22.7428H49V24.8628H46.9011V26.9617H44.8021V29.0607H42.7032V31.1596H40.5832V29.0607H38.5053V41.6543H36.4063V43.7533H19.5937V41.6543H17.4947V29.0607H15.4168V31.1596H13.2968V29.0607H11.1979V26.9617H9.09895V24.8628H7V22.7428H9.09895V20.6438H11.1979V18.5449H13.2968V16.4459H15.3958V14.347H17.4947V12.248Z"
          fill="currentColor"
        />
      </>
    </Icon>
  );
};
